<div class="modal-header">
  @if (!isNew) {
    <h4 class="modal-title">
      Event Detail
    </h4>
  }
  @if (isNew) {
    <h4 class="modal-title">
      New Event
    </h4>
  }
  <button class="btn btn-link text-secondary" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <fa-icon [icon]="faTimes"></fa-icon>
  </button>
</div>
<form [formGroup]="form" autocomplete="off" novalidate>
  <div class="modal-body">
    <div class="col-12">
      <div class="card py-3">
        <div class="col-12 ps-2">
          <div class="form-row mb-3">
            <div class="form-group">
              <label for="eventTitle">Event Title</label>
              <input id="eventTitle"
                style="width:400px"
                type="text"
                class="form-control"
                formControlName="eventTitle" />
              </div>
            </div>
            <div class="form-row mb-3">
              <div class="form-group">
                <label for="date">Event Date</label>
                <div class="input-group" style="width:260px">
                  <input class="form-control" id="date"
                    formControlName="date" placeholder="mm-dd-yyyy"
                    ngbDatepicker #date="ngbDatepicker"
                    [minDate]="datePickerMin" />
                    <button class="btn btn-primary calendar" (click)="date.toggle()" type="button"><fa-icon [icon]="faCalendar"></fa-icon></button>
                  </div>
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="form-group">
                  <label for="startTime">Event Start Time</label>
                  <div class="input-group" style="width:260px">
                    <span class="form-control">{{startTimeDisplay}}</span>
                    <button type="button"
                      class="btn btn-primary calendar"
                      placement="bottom"
                      #startPop="ngbPopover"
                      triggers="manual"
                      [autoClose]="'outside'"
                      (click)="startPop.toggle()"
                      (hidden)="convertTimeToDisplay()"
                      [ngbPopover]="startTimePicker">
                      <fa-icon [icon]="faClock"></fa-icon>
                    </button>
                  </div>
                  <ng-template #startTimePicker>
                    <ngb-timepicker formControlName="startTime" [meridian]="meridian"></ngb-timepicker>
                  </ng-template>
                </div>
              </div>
              <div class="form-row mb-3">
                <div class="form-group">
                  <label for="endTime">Event End Time</label>
                  <div class="input-group" style="width:260px">
                    <span class="form-control">{{endTimeDisplay}}</span>
                    <button type="button"
                      class="btn btn-primary calendar"
                      placement="bottom"
                      #endPop="ngbPopover"
                      triggers="manual"
                      [autoClose]="'outside'"
                      (click)="endPop.toggle()"
                      (hidden)="convertTimeToDisplay()"
                      [ngbPopover]="endTimePicker">
                      <fa-icon [icon]="faClock"></fa-icon>
                    </button>
                  </div>
                  <ng-template #endTimePicker>
                    <ngb-timepicker formControlName="endTime" [meridian]="meridian"></ngb-timepicker>
                  </ng-template>
                </div>
              </div>

              <div class="form-row mb-3">
                <div class="form-group" style="width:215px">

                  <label for="location">Event Location</label>
                  <input id="location"
                    type="text"
                    class="form-control"
                    formControlName="location" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="onEdit()" [disabled]="isSaving">
            Confirm
          </button>
          <button type="button" class="btn btn-danger" (click)="onDelete()" [disabled]="isNew || isSaving">
            Delete
          </button>
        </div>
      </form>

